  const c2bhandlers = {
    handleform:() => {
      resetCustomContentMinHeight();
    },
    handlecomplete:() => {
      document.querySelector('.text__standard .rte .rte').textContent = '';
    },
    handlecancel:() => {
      window.location.href = '/pages/contact';
    }
  };
function resetCustomContentMinHeight() {
  document.querySelectorAll('[data-section-type="custom-content"]').forEach(section => {
    section.style.minHeight = null;
    section.querySelectorAll('[data-overflow-frame]').forEach(block => {
      block.style.minHeight = null;
    });
  });
}